<template>
    <rkm-row>
        <rkm-col cols="12">
            <rkm-area
                class="mb-2"
                type="fieldset"
                title="ATRIBUIR PARA AS JORNADAS SELECIONADAS"
            >
                <rkm-form ref="RkmForm">
                    <rkm-row class="flex-nowrap">

                        <rkm-col cols="3">
                            <rkm-form-time-picker
                                label="Horário Inicial"
                                v-model="jornada.horaInicial"
                            />
                        </rkm-col>

                        <rkm-col cols="3">
                            <rkm-form-time-picker
                                label="Horário Final"
                                v-model="jornada.horaFim"
                            />
                        </rkm-col>

                        <rkm-col cols="3">
                            <rkm-form-select
                                :options="form.tipos"
                                label="Tipo de Jornada"
                                show-default-option
                                text-field="nome"
                                v-model="jornada.tipoId"
                                value-field="id"
                            />
                        </rkm-col>

                        <rkm-col class="flex-grow-1">
                            <rkm-form-input
                                label="Número de vagas"
                                v-model="jornada.vagas"
                            />
                        </rkm-col>


                        <rkm-col cols="auto">

                            <rkm-button
                                :label="false"
                                @click.stop="atribuir()"
                                color="primary"
                                :disabled="handleDisabled()"
                            >
                                Atribuir
                            </rkm-button>

                            <rkm-button
                                :label="false"
                                @click.stop="resetForm"
                                color="secondary"
                                :disabled="(!jornada.horaInicial && !jornada.horaFim && !jornada.vagas && !jornada.tipoId)"
                            >
                                Limpar
                            </rkm-button>
                        </rkm-col>
                    </rkm-row>
                </rkm-form>
            </rkm-area>
        </rkm-col>
    </rkm-row>
</template>

<script>

import { mapActions } from 'vuex'
import { repository, error, object, data, stringCase } from '@/mixins'

// Moment.
import moment from 'moment'

// Enuns.
import tipoJornada from '@/enums/exame-laboratorial/tipoJornada'

export default {
    data:() => ({
        jornada: {
            data: null,
            horaInicial: '',
            horaFim: '',
            infraestruturaId: null,
            diasSemana:null,
            semanaId: null,
            unidadeId: null,
            tipoId: null,
            vagas: '',
            periodo: {
                start: null,
                end: null,
            },
        },
        enums: {
            tipoJornada
        },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        atribuir() {

            this.$refs.RkmForm.validate()
                .then(valid => {

                    if (!valid) return

                    if(this.model.jornadasNotSave && this.model.jornadasNotSave.length > 0){

                        let msg = ''

                        this.model.jornadasNotSave.filter(item => item.selecionado).map((item, index) => {

                            const existeJornada = this.model.jornadasNotSave.find((j, i) => {
                                if (index === i) return false;

                                const horaInicial = moment(item.data.concat(' ', this.jornada.horaInicial), 'DD/MM/YYYY HH:mm:ss')
                                const horaFinal = moment(item.data.concat(' ', this.jornada.horaFim), 'DD/MM/YYYY HH:mm:ss')

                                const jHoraInicial = moment(j.data.concat(' ', j.horaInicial), 'DD/MM/YYYY HH:mm');
                                const jHoraFinal = moment(j.data.concat(' ', j.horaFim), 'DD/MM/YYYY HH:mm');

                                return moment(horaInicial).isBetween(jHoraInicial, jHoraFinal) ||
                                    moment(horaFinal).isBetween(jHoraInicial, jHoraFinal) ||
                                    moment(horaInicial).isSame(jHoraInicial) ||
                                    moment(horaFinal).isSame(jHoraFinal) ||
                                    moment(this.getFormatedDate(horaInicial, 'DD/MM/YYYY HH:mm')).isBefore(jHoraInicial) &&
                                    moment(this.getFormatedDate(horaFinal, 'DD/MM/YYYY HH:mm')).isAfter(jHoraFinal);
                            });

                            const verificaData = [item.data]

                            if(existeJornada){

                                for( let i = 0; i < verificaData.length; i++) {

                                    msg = msg.concat('<br/><strong>', verificaData[i], '</strong> - Conflito de horário.')
                                }
                            }

                            var horaInicial = this.jornada.horaInicial

                            if (!horaInicial) {
                                horaInicial = item.horaInicial
                            }

                            var horaFim = this.jornada.horaFim

                            if (!horaFim) {
                                horaFim = item.horaFim
                            }

                            var vagas = this.jornada.vagas

                            if (vagas && item.agendamentos > vagas) {

                                msg = msg.concat('<br/><strong>', verificaData, ' ', item.horaInicial, ' - ', item.horaFim, '</strong> ')
                                msg = msg.concat('- Não foi alterado o número de vagas, pois a quantidade de agendamtos é maior que número de vagas que está tentando atribuir.')

                                vagas = item.vagas
                            } else {

                                if (!vagas) {
                                    vagas = item.vagas
                                }
                            }

                            if (item.agendamentos == 0) {

                                var tipoId = this.jornada.tipoId

                                if (!tipoId) {
                                    tipoId = item.tipoId
                                }
                            } else {

                                if (this.jornada.tipoId) {
                                    msg = msg.concat('<br/><strong>', verificaData, ' ', item.horaInicial, ' - ', item.horaFim, '</strong> ')
                                    msg = msg.concat('- O tipo de jornada não foi alterado, pois já existem agendamentos associados.')
                                }
                            }

                            if(!existeJornada){

                                var timeFim = horaFim.substr(0, 5)
                                horaInicial = horaInicial.substr(0, 5)

                                var inicioFim = horaInicial.split(':')
                                var finalFim = timeFim.split(':')

                                var inicioTratadoF = parseInt(inicioFim[0]* 60) + parseInt(inicioFim[1])
                                var finalTratadoF = parseInt(finalFim[0]* 60) + parseInt(finalFim[1])

                                var diferencaMinutosF = finalTratadoF - inicioTratadoF

                                var totalSegundosF = diferencaMinutosF * 60

                                var verificaSegundoF = totalSegundosF / vagas

                                if (this.jornada.tipoId == this.enums.tipoJornada.FIXA) {

                                    if( verificaSegundoF < 60 && horaInicial != timeFim){

                                        this.showValidationNotification("O atendimento deve ter ao menos um minuto")

                                        return
                                    }

                                } else {

                                    if( verificaSegundoF < 60 ){

                                        this.showValidationNotification("O atendimento deve ter ao menos um minuto")

                                        return
                                    }
                                }

                                if(vagas && horaInicial && timeFim){

                                    item.tempoAtendimento = Math.floor(diferencaMinutosF / vagas)
                                }

                                if(this.jornada.horaInicial){

                                    if (!item.primeiroHorario || horaInicial < item.primeiroHorario) {

                                        item.horaInicial =  horaInicial
                                    } else {

                                        msg = msg.concat('<br/><strong>', verificaData, ' ', item.horaInicial, ' - ', item.horaFim),
                                        msg = msg.concat('</strong> - O horário inicial não foi alterado, pois existe agendamento para ')
                                        msg = msg.concat('<strong>', item.primeiroHorario.substr(0, 5) , '</strong>. Portanto, o horário inicial deve ser, no máximo, ')
                                        msg = msg.concat('<strong>', item.primeiroHorario.substr(0, 5), '</strong>.')
                                    }
                                }

                                if(this.jornada.horaFim){

                                    if (!item.ultimoHorario || timeFim > item.ultimoHorario) {

                                        item.horaFim =  timeFim
                                    } else {

                                        msg = msg.concat('<br/><strong>', verificaData, ' ', item.horaInicial, ' - ', item.horaFim),
                                        msg = msg.concat('</strong> - O horário final não foi alterado, pois existe agendamento para ')
                                        msg = msg.concat('<strong>', item.ultimoHorario.substr(0, 5) , '</strong>. Portanto, o horário final deve ser, no mínimo, ')
                                        msg = msg.concat('<strong>', item.ultimoHorario.substr(0, 5), '</strong>.')
                                    }
                                }

                                item.vagas = vagas
                                item.vagasDisponiveis = vagas-item.agendamentos

                                if(this.jornada.tipoId && item.agendamentos == 0){

                                    item.tipoId = this.jornada.tipoId
                                    item.tipoNome = this.form.tipos.find(s => s.id === this.jornada.tipoId).nome
                                }
                            }
                        })

                        this.mensagemConflito(msg)
                        this.resetForm()
                        this.$emit('getCalendar')
                    }
                })
        },
        getPrincipal(infraestruturaPrincipal) {

            let localAtendimento = infraestruturaPrincipal.find(u => u.principal === true)

            if(localAtendimento ){

                this.jornada.infraestruturaId = localAtendimento.id
            } else {

                this.jornada.infraestruturaId = null
            }
        },
        mensagemConflito(msg){

            if(msg){

                this.showAlert('Não foi possível realizar as seguintes atribuições: '  + msg)
            }
        },
        resetForm() {

            this.jornada.vagas = ''
            this.jornada.horaInicial = ''
            this.jornada.horaFim = ''
            this.jornada.tipoId = null
        },
        handleDisabled() {

            return this.jornada.horaInicial && this.selecionados
                || this.jornada.horaFim && this.selecionados
                || this.jornada.vagas && this.selecionados
                || this.jornada.tipoId && this.selecionados ? false : true
        }
    },
    mixins: [ repository, error, object, data, stringCase ],
    props: {
        form: { type: Object, required: true },
        model: { type: Object, required: true },
        id: { type: Number },
        selecionados: { type: Boolean }
    },
}
</script>